/**
 * 연혁 컴포넌트
 * props로 받은 연혁 데이터를 연도별로 표시합니다.
 */

import React from 'react';
import styled from 'styled-components';

/**
 * History 컴포넌트
 * @param {Array} historyData - 연혁 데이터 배열
 */
function History({ historyData }) {
  return (
    <Container>
      {historyData.map((yearData) => (
        <YearSection key={yearData.year}>
          <Year>{yearData.year}</Year>
          <EventList>
            {yearData.events.map((event, index) => (
              <EventItem key={index}>
                <EventDate>{event.date}</EventDate>
                <EventTitle>{event.title}</EventTitle>
                {event.description && (
                  <EventDescription>{event.description}</EventDescription>
                )}
              </EventItem>
            ))}
          </EventList>
        </YearSection>
      ))}
    </Container>
  );
}

export default History;

/* Styled Components */

const Container = styled.div`
  margin-top: 40px;
  border-top: 2px solid #e5857c;
  border-bottom: 2px solid #e5857c;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    margin-top: 20px;
  }
`;

const YearSection = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  margin: 0;
  padding: 0;
  align-items: flex-start;
  border-bottom: 1px dashed #e5857c;
  padding: 30px 0;

  /* 모바일 스타일 - 세로 배치 */
  @media (max-width: 767px) {
    flex-direction: column;
    padding: 20px 5%;
  }
`;

const Year = styled.h3`
  color: #e5857c;
  font-size: 28px;
  margin: 0;
  padding: 0;
  margin: 0 40px 0 15px;
  flex-shrink: 0;
  font-family: 'koPubWorld DotumB';
  line-height: 40px;

  /* 모바일 스타일 - 년도를 위에 표시 */
  @media (max-width: 767px) {
    font-size: 22px;
    margin: 0 0 15px 0;
    width: 100%;
  }
`;

const EventList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const EventItem = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  margin: 0;
  padding: 0;

  &:last-child {
    margin-bottom: 0;
  }

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    margin-bottom: 15px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const EventDate = styled.h4`
  width: 90px;
  text-align: right;
  color: #e5857c;
  font-size: 20px;
  margin: 0;
  padding: 0;
  margin: 0 50px 0 0;
  flex-shrink: 0;
  line-height: 40px;
  font-family: 'koPubWorld DotumB';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    width: auto;
    text-align: left;
    font-size: 16px;
    margin: 0 0 5px 0;
    line-height: 1.5;
    padding-left: 1%;
  }
`;

const EventTitle = styled.p`
  font-weight: bold;
  font-size: 15px;
  margin: 0;
  padding: 0;
  line-height: 40px;
  flex: 1;
  font-family: 'koPubWorld DotumB';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    padding-left: 3%;
  }
`;

const EventDescription = styled.span`
  font-size: 15px;
  width: 100%;
  margin: 0;
  padding: 0;
  margin-left: 140px;
  font-family: 'koPubWorld DotumM';
  display: block;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 13px;
    margin-left: 0;
    margin-top: 5px;
    line-height: 1.5;
    padding-left: 3%;
  }
`;
